// extracted by mini-css-extract-plugin
export default {"icon":"ButtonGroupIcon_icon__tr1vQ"};